export const sortObjectKeysAlphabetically = (rawObject = {}) => Object.keys(rawObject)
    .sort()
    .reduce((acc, currentKey) => ({
        ...acc,
        [currentKey]: rawObject[currentKey],
    }), {});


export default { sortObjectKeysAlphabetically };
